export const errorCodes = {
  APPLICATION_SETTINGS_NOT_FOUND: 400146,
  BRAND_NOT_FOUND: 4000370,
};
